(function (window, document, $) {
    'use strict';

    $(function() {
        const $accordionHeadline = $('.accordion-item--headline');

        $accordionHeadline.on('click', function () {
            $(this).parent('.accordion-item').toggleClass('active');
        });

        const hashChanged = (hash) => {
            let $accordionItem = $(hash).closest('.accordion-item')
            if ($accordionItem.length && !$accordionItem.hasClass('active')) {
                $(hash).trigger('click');
            }
        }

        window.addEventListener('load', (event) => {
            hashChanged(window.location.hash);
        });

        if ("onhashchange" in window) { // event supported?
            window.onhashchange = function () {
                hashChanged(window.location.hash);
            }
        } else { // event not supported:
            let storedHash = window.location.hash;
            window.setInterval(function () {
                if (window.location.hash !== storedHash) {
                    storedHash = window.location.hash;
                    hashChanged(storedHash);
                }
            }, 100);
        }
    });

}(window, document, jQuery));